import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
  IconButton,
  Snackbar,
  SnackbarContent,
} from '@material-ui/core';
import React from 'react';

import { deleteReport, IReport } from '~/src/dash/api/console-api';
import { IStore } from '~/src/dash/reducers/store';
import { ISessionStateProps, IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';

export interface IReportDeleteDialogProps extends IWithStylesProps, ISessionStateProps {
  report?: IReport;
  onClose?: (reportID: string) => void;
  onError?: (reportID: string) => void;
  onAccept?: (reportID: string) => void;
}

interface IState {
  Name: string;
  ID: string;
  state: number;

  err: boolean;
}

const dialogClosed = 0;
const dialogOpen = 1;
const dialogSnackbar = 2;

export const ReportDeleteDialog = decorate(
  {
    redux: (state: IStore) => {
      return {
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      icon: {
        fontSize: '1rem',
        marginRight: '1rem',
      },
      error: {
        backgroundColor: theme.palette.error.dark,
      },
      message: {
        display: 'inline-flex',
        'align-items': 'center',
      },
    }),
  },
  class extends React.Component<IReportDeleteDialogProps, IState> {
    state = {
      Name: '',
      ID: '',
      state: dialogClosed,
      err: false,
    };

    onClose = () => {
      if (this.props.onClose) {
        this.props.onClose(this.state.ID);
      }
      this.setState({
        state: dialogClosed,
        err: false,
      });
    };

    onError = () => {
      if (this.props.onError) {
        this.props.onError(this.state.ID);
      }
      this.setState({
        state: dialogSnackbar,
        err: true,
      });
    };

    onAccept = () => {
      if (this.props.onAccept) {
        this.props.onAccept(this.state.ID);
      }
      this.setState({
        state: dialogSnackbar,
        err: false,
      });
    };

    componentDidUpdate(prevProps: IReportDeleteDialogProps) {
      if ((prevProps.report || ({} as IReport)).ID !== (this.props.report || ({} as IReport)).ID) {
        this.setState({
          ID: (this.props.report || ({} as IReport)).ID,
          Name: (this.props.report || ({} as IReport)).Name,
          state: this.props.report ? dialogOpen : dialogClosed,
          err: false,
        });
      }
    }

    render() {
      const { classes } = this.props;
      return (
        <div>
          <Dialog
            open={this.state.state === dialogOpen}
            onClose={this.onClose}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle>Delete: {this.state.Name}?</DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                Should {this.state.Name} be removed?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onClose} color='primary' autoFocus>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  deleteReport({
                    query: {
                      publisher_id: this.props.session.publisher.ID,
                      report_id: this.state.ID,
                    },
                  }).then(this.onAccept, this.onError);
                }}
              >
                Yes, delete
              </Button>
            </DialogActions>
          </Dialog>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            open={this.state.state === dialogSnackbar}
            autoHideDuration={6000}
            onClose={this.onClose}
          >
            <SnackbarContent
              aria-describedby='client-snackbar-report-delete-dialog'
              message={
                <span id='client-snackbar-report-delete-dialog' className={classes.message}>
                  <Icon className={classes.icon}>
                    {this.state.err ? 'warning' : 'check_circle'}
                  </Icon>
                  {this.state.err
                    ? `Failed to delete report: [${this.state.ID}] ${this.state.Name}`
                    : `Deleted report: [${this.state.ID}] ${this.state.Name}`}
                </span>
              }
              action={[
                <IconButton key='close' aria-label='Close' color='inherit' onClick={this.onClose}>
                  <Icon>close</Icon>
                </IconButton>,
              ]}
            />
          </Snackbar>
        </div>
      );
    }
  },
);
